import { onBeforeUnmount, ref } from 'vue'

/** prefers-reduced-motion as a ref (false where matchMedia is missing). */
export function reducedMotionNow () {
  try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) } catch (e) { return false }
}

export function useReducedMotion () {
  const reduced = ref(reducedMotionNow())
  let mq = null
  const onChange = (e) => { reduced.value = !!e.matches }
  try {
    mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null
    if (mq && mq.addEventListener) mq.addEventListener('change', onChange)
  } catch (e) { mq = null }
  onBeforeUnmount(() => { try { if (mq && mq.removeEventListener) mq.removeEventListener('change', onChange) } catch (e) { /* */ } })
  return reduced
}
